import { Component } from '@angular/core';
import { NavController, Platform, ModalController } from '@ionic/angular/standalone';
// import { Events } from '@ionic/angular/standalone';
import { WalletService } from 'src/app/services/wallet.service';
import { HomeService } from 'src/app/services/home.service';
import { MembershipService } from 'src/app/services/membership.service';
import { AppStateService } from 'src/app/services/init/app-state.service';
import { Router } from '@angular/router';
import { storageKeys } from 'src/app/app.constants';
import { ProfileService } from 'src/app/services/profile.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/services/common.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AnalyticsService } from 'src/app/services/core/analytics/analytics.service';
import { analyticsData } from '../../../../analytics.constants'
import { environment } from '../../../../../environments/environment'
import { LocalizationService } from 'src/app/services/core/localize/localization.service';
import { EventService } from 'src/app/services/core/event/event.service';
import { ViewBenefitVideoModalComponent } from 'src/app/modals/view-benefit-video-modal/view-benefit-video-modal.component';
import { GiftreceiverComponent } from 'src/app/modals/giftreceiver/giftreceiver.component';
import { SignUpService } from 'src/app/services/sign-up.service';
import { InitializationService } from 'src/app/services/core/optimisation/initialization.service';
import { IonButton, IonButtons, IonCard, IonContent, IonFooter, IonIcon, IonItem, IonItemGroup, IonLabel, IonRadio, IonRadioGroup, IonSkeletonText } from '@ionic/angular/standalone';
import { WebHeaderComponent } from 'src/app/components/web-header/web-header.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MembershipCardComponent } from 'src/app/components/membership-card/membership-card.component';


@Component({
  selector: 'app-card-wallet',
  templateUrl: './card-wallet.component.html',
  styleUrls: ['./card-wallet.component.scss'],
  imports : [
    IonContent,
    IonItem,
    IonLabel,
    IonIcon,
    IonItemGroup,
    IonRadioGroup,
    IonRadio,
    IonButton,
    IonButtons,
    IonCard,
    IonSkeletonText,
    IonFooter,
    WebHeaderComponent,
    FormsModule,
    TranslateModule, 
    CommonModule,
    MembershipCardComponent
  ]
})
export class CardWalletComponent {

  brandName: any;
  walletData = [];
  localWalletData = [];
  aemIdentifier = [];
  giftedMembership = [];
  diffDays: number;
  cardType: string;
  expiryProgress: number;
  showUserImg: any;
  skeleton: boolean;
  membershipNumber: any;
  selectedCard: any;
  showWallet: boolean;
  availableMembership: boolean = false;
  buyMembershipWallet: boolean = false;
  staticContent: any;
  select: any;
  lang: string;
  loginServiceDataUpdated: { aemIdentifier: string; aemUrl: any; currentUrlPath: any; isLoggedIn: any; membershipNumber: any; subBrandIdentifier: any; userImage: any; };
  appInitData: any;

  constructor(
    private walletService: WalletService,
    private homeService: HomeService,
    private navCtrl: NavController,
    private memberService: MembershipService,
    public appState: AppStateService,
    private events: EventService,
    public router: Router,
    public profileService: ProfileService,
    public translateServ: TranslateService,
    public commonServ: CommonService,
    public domSanitizer: DomSanitizer,
    public plt: Platform,
    // public file: File,
    public modalCtrl: ModalController,
    private analyticsService: AnalyticsService,
    private localization: LocalizationService,
    public translate: TranslateService,
    public signupService: SignUpService,
    private initService : InitializationService
  ) {
    console.log("showUserImg", this.showUserImg);
    if(this.initService.imageBase64){
      console.log("init base 64 is  available card wallet")
      this.showUserImg= this.initService.imageBase64;
    }
    else  if(localStorage.getItem(environment?.headers?.program_id + ":" + 'imageUrlbase64') && localStorage.getItem(environment?.headers?.program_id + ":" + 'imageUrlbase64') != "null"){
      this.showUserImg = localStorage.getItem(environment?.headers?.program_id + ":" + 'imageUrlbase64');
      console.log("this.Showuserimglocal1", this.showUserImg);
   }
   else {
      console.log("init base 64 is not available")
      this.showUserImg = "";
    }
    // console.log("init base 64 is not available", this.showUserImg);

    this.walletData = JSON.parse(localStorage.getItem(environment?.headers?.program_id + ":" + 'walletData'));
    let localWalletData = localStorage.getItem(environment?.headers?.program_id + ":" + 'walletData');
    if (localWalletData) {
      this.localWalletData = JSON.parse(localWalletData);
    }
  }

  ionViewWillEnter() {
     console.log("this.initisation ")
    if(this.initService.imageBase64){
      // console.log("this.initisation from view enter434", this.initService.imageBase64)
      this.showUserImg = this.initService.imageBase64;
      
    }
    else  if(localStorage.getItem(environment?.headers?.program_id + ":" + 'imageUrlbase64') && localStorage.getItem(environment?.headers?.program_id + ":" + 'imageUrlbase64') != "null"){
      this.showUserImg = localStorage.getItem(environment?.headers?.program_id + ":" + 'imageUrlbase64');
      console.log("this.Showuserimglocal12", this.showUserImg);
   }
    else  {
      
      this.showUserImg = "";
    }

    this.lang = this.appState.preferredLanguage || this.localization.getDeviceLanguage();
    this.brandName = {
        brandName:  this.translate.instant('configJson.brandsName')
      }
    this.select = this.commonServ.cardWalletBackButtonSelect
    this.staticContent = storageKeys;
    const appData = this.appState.getAppData();
    //console.log('AppStateData ==>', appData);
    if (appData && appData?.membershipNumber) {
      this.availableMembership = true;
      this.membershipNumber = appData.membershipNumber.membershipNumber;
    }
    if ( (appData && appData?.visitor && appData?.visitor?.visitor != "") || (appData?.homeDetails?.cardDetails?.level == storageKeys?.appUser)) {
      this.availableMembership = false;
    }
    if (appData && appData?.appInitData) {
      this.appInitData = appData.appInitData;
    }
    if (appData && appData?.appInitData?.collapsible) {
      appData.appInitData.collapsible.forEach(obj => {
        if (obj.category == "buyMembershipCardWallet") {
          this.buyMembershipWallet = obj.value;
        }
      })
    }
    console.log("before wallet method")
    this.getWalletData();

    if (this.plt.is("ipad") || this.plt.is("ios") || this.plt.is("iphone")) {
      this.showWallet = true;
    } else {
      this.showWallet = false;
    }
    if (appData && appData?.homeDetails) {
 
      if(this.initService.imageBase64 ||localStorage.getItem(environment?.headers?.program_id + ":" + 'imageUrlbase64') && localStorage.getItem(environment?.headers?.program_id + ":" + 'imageUrlbase64') != "null" )   {
        // return ;
      } else {
        this.showUserImg = this.profileService.profilePicLoading(appData?.homeDetails);
      }
 
  }
    this.AnalyticsFunc();
  }

  // AnalyticsFunct
  AnalyticsFunc() {
    let memeberidEncrpit = this.appState.getEncryptedMemberId();
    this.analyticsService.trackState(analyticsData.cardWalletState, analyticsData.cardWalletCdata, memeberidEncrpit);
  }


  // Function to receive wallet data from walletService
  getWalletData() {
    console.log("in wallet method")
    this.walletService.getWalletData().then(
      (res) => {
        if (res) {
          this.filterWalletCards(res);
        }
      }
    ).finally(
      () => {
        this.skeleton = false;
      }
    );
  }

  filterWalletCards(walletApiResponse) {
    this.walletData = [];
    walletApiResponse.aemIdentifier.forEach(
      (element1) => {
        element1.customerSets.forEach(
          (element2, index: any) => {
            let data: any = {
              firstName: walletApiResponse.name.firstName,
              lastName: walletApiResponse.name.lastName,
              validThrough: element2.validThru,
              validThroughshow: element2.validThruShow,
              highestSpender: element2.highestSpender,
              membershipType: element2.level,
              startFrom: element2.startFrom,
              membershipNumber: element2.membershipNumber,
              giftReceivedFrom: element2.gifteeMembershipDetails?.giftReceivedFrom,
              giftReceivedDate: element2.gifteeMembershipDetails?.giftReceivedDate,
              giftText: element2.gifteeMembershipDetails?.giftText,
              giftVideo: element2.gifteeMembershipDetails?.giftVideo,
              giftedDate: element2.gifteeMembershipDetails?.giftedDate,
              gifteeName: element2.gifteeMembershipDetails?.gifteeName,
              isMembershipGifted: element2.gifteeMembershipDetails?.isMembershipGifted,
              aemIdentifier: [
                {
                  propertyIdentifier: element1.propertyIdentifier,
                  subBrandIdentifier: element1.subBrandIdentifier,
                  subBrandName: element1.subBrandName,
                  customerSets: []
                }
              ]
            }
            const wallet = this.localWalletData?.find(x => x.membershipNumber === element2.membershipNumber)
            if (wallet) {
              data.cardImage = wallet.cardImage;
              data.propertyLogo = wallet.logoImage;
            }
            data.aemIdentifier[0].customerSets.push(element2)
            this.walletData.push(data)
          }
        );
      }
    );
    this.getCustomerSets();
    this.walletData.forEach(ele => {
        if( ele.membershipNumber === this.membershipNumber){
            console.log("element selected-->",ele)
            this.changeMembershipCard(ele)
        }
    })
  }

  async getCustomerSets() {
    if (this.walletData) {
      let customerSets = [];
      const appData = this.appState.getAppData()
      this.walletData.forEach(
         (element) => {
          element.aemIdentifier.forEach(
            (elmnt) => {
              elmnt.customerSets.forEach(
                (ele) => {
                  customerSets.push(environment.identifierUrl + (appData.appInitData?.currentCountry || environment.currentCountry) + `/${this.lang}` + ele.customerSetIdentifier);
                }
              );
            }
          );
        }
      );
      let data = {
        membershipType: customerSets
      }
      this.homeService.getSelectMembershipImageFunc(data).then(  //reafctored code
        (res) => {
          this.walletData.forEach(
            (element) => {
              this.updateCardType(element, res);
            }
          );
          localStorage.setItem(environment?.headers?.program_id + ":" + 'walletData', JSON.stringify(this.walletData));
        }
      );
    }
  }


  updateCardType(element, response) {
    console.log("elem --->>",element)
    var curDate = new Date();
    var validDate = new Date(element.validThrough);
    this.diffDays =
      Math.ceil((validDate.getTime() - curDate.getTime()) / (1000 * 3600 * 24));
    if (this.diffDays >= 0) {
        if (Number(this.diffDays) < element.aemIdentifier[0].customerSets[0].renewCount) {
            element.cardType = this.staticContent.cardAboutToExpire;
            element.diffDays = this.diffDays;
            element.expiryProgress = (this.diffDays * 100) / element.aemIdentifier[0].customerSets[0].renewCount;
        } else {
            element.cardType = this.staticContent.validCard;
        }
    } else {
        let reactivedays = this.diffDays + element.aemIdentifier[0].customerSets[0].reactivateCount;
        if(reactivedays <= 0){
            element.cardType = this.staticContent.cardExpired;
        }else{
            element.cardType = this.staticContent.expireCard;
        }
    }
    this.compareCardImageWithLevelType(element, response);
  }

  compareCardImageWithLevelType(element, res) {
    element.aemIdentifier.forEach(
      (elmnt) => {
        elmnt.customerSets.forEach(
          (ele) => {
            for (var i = 0; i < res.length; i++) {
              if (res[i].type === ele.customerSetIdentifier.substring(ele.customerSetIdentifier.lastIndexOf('/') + 1, ele.customerSetIdentifier.length)) {
                element.cardImage = res[i].cardImage;
                element['propertyLogo'] = res[i].logoImage
              }
            }
          }
        );
      }
    );
    //console.log('each card =====>>>', element);
  }

  navigateToActivation(val) {

      //DISABLE-POP-UP
      // const modal = await this.modalCtrl.create({
      //   component: DisablePopupComponent,
      //   mode: 'ios'
      // });
      // modal.present();
      // END: DISABLE-POP-UP

      // ENABLE-CODE
      // if (val != 'visitor') {
      //   this.homeService.renewHeading = val;
      //   this.navCtrl.navigateForward("/reactivate-membership");
      // } else {
      //   const modal = await this.modalCtrl.create({
      //     component: EnrollModalComponent,
      //     componentProps: { type: "buy" }
      //   });
      //   modal.present();
      //   // this.navCtrl.navigateForward("/promo-code", {queryParams: {"type": "buy"}});
      // }
      // END: ENABLE-CODE

  }

  onBackButtonFunc() {
    // this.navCtrl.navigateRoot('/tabs/membership');
    this.navCtrl.navigateRoot('/tabs/home');
  }
  

  async buyAnotherMembership(event) {
    // console.log("check type =>",('currentTarget' in event))
    let memeberidEncrpit = this.appState.getEncryptedMemberId();
    this.analyticsService.trackAction(event.currentTarget.innerText, analyticsData.cardWalletAction, analyticsData.cardWalletActionCtaName, memeberidEncrpit);
    // if(environment?.uiVersion == 1) {
    //     this.navCtrl.navigateForward('/BuyAnotherMembership', { queryParams: { promocode: false, appliedPromocode: "", flowType: this.availableMembership ? "another" : "visitor" } });
    // } else 
       this.navCtrl.navigateForward('buy-another/hotel-specific-membership', { queryParams: { promocode: false, appliedPromocode: "", flowType: this.availableMembership ? "another" : "visitor" } });
    // if(environment?.uiVersion == 2) {
    //     this.navCtrl.navigateForward('/buy-another-subscription', { queryParams: { promocode: false, appliedPromocode: "", flowType: this.availableMembership ? "another" : "visitor" } });
    // } else if(environment?.uiVersion == 3 || environment?.uiVersion == 1) {

    //       this.signupService.promoCode = null;
    //       this.signupService.promocodeApiResponse = null;
    //       this.signupService.promocodeApplied = false;
    //       if (!(this.appInitData.buyMembership.nationalSubscription && this.appInitData.buyMembership.hotelSpecific)) {
    //           if (this.appInitData.buyMembership.nationalSubscription) {
    //               this.navCtrl.navigateForward('buy-another-subscription', { queryParams: { promocode: false, appliedPromocode: "", flowType: this.availableMembership ? "another" : "visitor" } });
    //           } else if (this.appInitData.buyMembership.hotelSpecific) {
    //               this.navCtrl.navigateForward('buy-another/hotel-specific-membership', { queryParams: { promocode: false, appliedPromocode: "", flowType: this.availableMembership ? "another" : "visitor" } });
    //           }
    //       } else {
    //           this.navCtrl.navigateForward('/select-plan-buy-another', { queryParams: { promocode: false, appliedPromocode: "", flowType: this.availableMembership ? "another" : "visitor" } });
    //       }
    // }
    // const modal = await this.modalCtrl.create({
    //   component: EnrollModalComponent,
    //   componentProps: { type: "buy", flow:"another" }
    // });
    // modal.present();

    // This modal has been implemented after Shailendra sir and sonal ma'am asked.

    //     const modal = await this.modalCtrl.create({
    //       component: DisablePopupComponent,
    //       mode: 'ios'
    //       // componentProps: { type: "gift" }
    //     });
    //     modal.present();


    // this.navCtrl.navigateForward('promo-code', {queryParams: {"type": "buy"}});
    // this.navCtrl.navigateForward('BuyAnotherMembership');
  }

  changeMembershipCard(event?: any) {
    if (!this.walletData?.length) return
    let card = this.walletData.find(obj => obj.membershipNumber == event.detail.value);
    if (card) {
      this.selectedCard = card;
      this.membershipNumber = card.membershipNumber;
    }
  }

  // Navigate To Membership Tab
 async  navToMembership(event) {
    const appData = this.appState.getAppData()
    if (!this.selectedCard || appData?.membershipNumber?.membershipNumber === this.membershipNumber) {
      return;
    }
    console.log("this.selectedCard--->>",this.selectedCard)
    if (this.membershipNumber == this.homeService.membershipNumber) {
      return;
    }
    let memeberidEncrpit = this.appState.getEncryptedMemberId();
    this.analyticsService.trackAction(event.currentTarget.innerText, analyticsData.cardWalletAction, analyticsData.cardWalletActionCtaName, memeberidEncrpit);
    let aemIdentifier = {
      propertyIdentifier: this.selectedCard.aemIdentifier[0].propertyIdentifier,
      customerSets: this.selectedCard.aemIdentifier[0].customerSets[0]
    };
    this.homeService.membershipNumber = this.selectedCard.aemIdentifier[0].customerSets[0].membershipNumber;
    this.memberService.membershipNumber = this.selectedCard.aemIdentifier[0].customerSets[0].membershipNumber;
    this.appState.saveMembershipNumber({ membershipNumber: this.membershipNumber });
    this.appState.removeData(storageKeys.aemCachedData)
    let aemUrl = this.homeService.createDynamicURL(aemIdentifier, this.selectedCard.aemIdentifier[0].subBrandIdentifier, 'save');
    const appStateData = this.appState.getAppData();
    if (appStateData.loginService) {
      const loginService = appStateData.loginService;
      this.loginServiceDataUpdated = {
        "aemIdentifier": JSON.stringify(aemIdentifier),
        "aemUrl": aemUrl,
        "currentUrlPath": loginService.currentUrlPath,
        "isLoggedIn": "true",
        "membershipNumber": this.selectedCard.aemIdentifier[0].customerSets[0].membershipNumber,
        "subBrandIdentifier": this.selectedCard.aemIdentifier[0].subBrandIdentifier,
        "userImage": loginService.userImage || ''
      };
    }
    //console.log('Memebership Number---->>>', this.membershipNumber, aemUrl);
    if(this.selectedCard.aemIdentifier[0].customerSets[0].level != "App User"){
        this.appState.saveMembershipTypeID({ 'membershipTypeID': this.selectedCard.aemIdentifier[0].customerSets[0].levelID });
        this.appState.saveVisitor({
          visitor: ''
        })
    }
    this.translateServ.get('loader.fetchData').subscribe((res: string) => {
      this.commonServ.presentLoader(res)
    });
    this.homeService.setDefaultMembershipNumber().then(res => { //reafctored code
      if (res) {

      }
    }, err => {
      this.homeService.handleAPIError(err);
    })
    this.homeService.getHomeCRMDetails().then(homeDetails => {
      if (homeDetails) {
        this.memberService.getMembershipCRMDetailsWithoutLoader().then(res => {  //reafctored code
          if (res) {
            this.profileService.getProfileDetails().then(res => {
              if (res) {
                this.appState.saveProfileDetails(res);
                if (this.loginServiceDataUpdated) {
                  //console.log('updated login service data =====>>>>', this.loginServiceDataUpdated);
                  this.appState.saveLoginServiceData(this.loginServiceDataUpdated);
                }
                this.commonServ.isSpouseJustAdded = false;
                // this.navCtrl.navigateRoot('/tabs/membership');
                this.navCtrl.navigateRoot('/tabs/home');
                this.homeService.subscriptionType.next(homeDetails.cardDetails?.subscriptionType);
                // this.router.navigate(['/tabs/membership']);
                this.memberService.membershipChange.next(true);
                this.events.publish('tabsMembershipUpdate', '');
                this.commonServ.dismissLoader();
              } else {
                this.commonServ.dismissLoader();
              }
            }, err => {
              this.commonServ.dismissLoader();
              this.homeService.handleAPIError(err);
            })
          } else {
            this.commonServ.dismissLoader();
          }
        }, err => {
          this.commonServ.dismissLoader();
          this.homeService.handleAPIError(err)
        })
      } else {
        this.commonServ.dismissLoader();
      }
    }, err => {
      this.commonServ.dismissLoader();
      this.homeService.handleAPIError(err)
    });
  }

  walletAddWeb() {
    console.log("walletAddWeb ", this.showWallet);
    if(this.showWallet){
      const appData = this.appState.getAppData();
      let appleWalletUrl = appData?.homeDetails?.cardDetails?.AppleWalletUrl;
      if (appData?.membershipNumber?.membershipNumber != this.membershipNumber) {
        this.homeService.getMembershipcardData(this.membershipNumber).then(res => {
          if(res){
            appleWalletUrl = res.cardDetails?.AppleWalletUrl;
            window.open(appleWalletUrl, "_blank");
           }
         });
      }
      else
      {
        window.open(appleWalletUrl, "_blank");
      }
    }else {
      this.homeService.walletCardAddWeb(this.membershipNumber).then(res => {
        if(res['code'] == 200){
          window.open(res['url'], "_blank");      
    }
     });
    }
  }

  walletAdd() {
    let data = {
      "pkPassType": "Create",
    }

    this.homeService.walletCardAdd(data, this.membershipNumber).subscribe(res => {
      if (res) {
        console.log("walletCardAdd", res.body);
        var blob = res.body;
        console.log("blob ==>", blob);
        const data = new Uint8Array(res.body);
        const dataUri = 'data:application/vnd.apple.pkpass;base64,' + btoa(String.fromCharCode.apply(null, data));
        console.log("dataUri ==>", dataUri);
        const link = document.createElement('a');
        link.href = dataUri;
        link.download = 'pass.pkpass';
        link.click();
        // var url= window.URL.createObjectURL(blob);
        // console.log("url ==>", url);
        // window.open(url);
        this.commonServ.dismissLoader()
        const fileName = "response.pkpass";
       
      }
    }, err => {
      this.commonServ.dismissLoader()
      //console.log('err--->', err)
    })

  }

  async openModalViewGiftMembership(giftMembership) {
    this.giftedMembership = [];
    this.giftedMembership.push(giftMembership);
    console.log("GiftMembership-flow- ", JSON.stringify(this.giftedMembership));
    if (this.giftedMembership[0].giftText) {
      let viewBenefitModal = await this.modalCtrl.create({
        component: ViewBenefitVideoModalComponent,
        backdropDismiss: false,
        componentProps: { gift: this.giftedMembership }
      });
      viewBenefitModal.present();
    }else{
      let viewBenefitModal = await this.modalCtrl.create({
        component: GiftreceiverComponent,
        backdropDismiss: false,
        componentProps: { gift: this.giftedMembership }
      });
      viewBenefitModal.present();
    }
    
  }

  trackByMembershipNumber(_index: number, walletItem: any) {
    return walletItem?.membershipNumber
  }

}